import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UrlParamsService {

  private lessonIdSubject: BehaviorSubject<number>;
  public lessonIdValue: Observable<number>;

  private activityIdSubject: BehaviorSubject<number>;
  public activityIdValue: Observable<number>;

  constructor(private route: ActivatedRoute) {
    this.lessonIdSubject = new BehaviorSubject<number>(JSON.parse(sessionStorage.getItem('lessonId')) || route.snapshot.paramMap.get('lessonId'));
    this.lessonIdValue = this.lessonIdSubject.asObservable();
    this.activityIdSubject = new BehaviorSubject<number>(JSON.parse(sessionStorage.getItem('activityId')) || route.snapshot.paramMap.get('activityId'));
    this.activityIdValue = this.activityIdSubject.asObservable();
  }

  public get lessonId() {
    return this.lessonIdSubject.value;
  }

  public get activityId() {
    return this.activityIdSubject.value;
  }

  public queryParamsToObject(url: string) {
    const result = {}
    const queryParams = new URL(url).search.replace('?', '')
    let params = new URLSearchParams(queryParams);
    params.forEach((value, key)=>{
      result[key] = value;
    })
    return result;
  }
}
